import React from 'react';
import { useTranslate } from 'react-admin';
import DynamicCell from '../components/misc/DynamicCell';
import TicketRefundCell from '../components/tickets/TicketRefundCell';
import {
  formatTicketDate,
  formatTicketChannel,
  formatUserFullName,
  formatEventName,
  formatProductInfo,
  formatProductKey,
  getTicketUsageColor,
  getTicketPrintUrls,
  formatTicketRefund,
} from '../utils/ticketsUtils';

const TicketPrintCell = ({ pnr }) => {
  const translate = useTranslate();
  const urls = getTicketPrintUrls(pnr);
  return (
    <>
      <a href={urls.ticket} target="_blank" rel="noreferrer">
        {translate('tickets.print_ticket', { _: 'Bilet' })}
      </a>{' '}
      &nbsp;| &nbsp;
      <a href={urls.print8cm} target="_blank" rel="noreferrer">
        8cm
      </a>
    </>
  );
};

const TicketChannelCell = ({ channel }) => {
  const translate = useTranslate();
  return formatTicketChannel(channel, translate);
};

const TicketIsUsedCell = ({ ticket }) => {
  const translate = useTranslate();
  if (ticket.isUsed) {
    return (
      <div
        style={{
          backgroundColor: getTicketUsageColor(ticket.isUsed),
          textAlign: 'center',
          borderRadius: 5,
          padding: 3,
        }}
      >
        <span style={{ color: 'white', padding: 2 }}>
          <DynamicCell
            id={ticket.isUsedBy}
            reference="users"
            renderFunction={(r) => `${r.name} ${r.surname.toString()[0]}.`}
          />
        </span>
      </div>
    );
  } else {
    return (
      <div
        style={{
          backgroundColor: getTicketUsageColor(ticket.isUsed),
          textAlign: 'center',
          borderRadius: 5,
          padding: 3,
        }}
      >
        <span style={{ color: 'white', textAlign: 'center' }}>
          {translate('tickets.usage_no', { _: 'Hayır' })}
        </span>
      </div>
    );
  }
};

export const TICKETS_TABLE = {
  entity: 'tickets',
  defaults: {
    pageSize: 100,
    pageSizeOptions: [25, 50, 100],
    visible: {
      id: false,
      coupon: false,
      payment: true,
      channel: false,
    },
    orderBy: { field: 'created', dir: 'desc' },
    limit: 0,
  },
  columns: [
    { field: 'id', headerName: 'ID', width: 100 },
    { field: 'pnr', headerName: 'PNR', width: 120 },
    {
      field: 'print',
      headerName: 'Print Ticket',
      width: 150,
      renderCell: (params) => <TicketPrintCell pnr={params.row.pnr} />,
    },
    {
      field: 'channel',
      headerName: 'Sale Channel',
      width: 80,
      renderCell: (params) => <TicketChannelCell channel={params.row.channel} />,
      valueGetter: (params) => params.row.channel ?? '',
      type: 'singleSelect',
      valueOptions: [
        { value: 'w', label: 'Website' },
        { value: 'm', label: 'Mobile' },
        { value: 'sp', label: 'Sale Point' },
        { value: 'sa', label: 'Sale Agent' },
        { value: 'op', label: 'Org C. Promoter' },
        { value: 'vp', label: 'Venue Promoter' },
        { value: 'a', label: 'Affiliate' },
        { value: 'ocm', label: 'Org C. Manager' },
        { value: 'vm', label: 'Venue Manager' },
      ],
    },
    {
      field: 'userName',
      headerName: 'User',
      width: 120,
      valueGetter: (params) => formatUserFullName(params.row.user),
    },
    {
      field: 'eventName',
      headerName: 'Event Name',
      width: 250,
      valueGetter: (params) => formatEventName(params.row.event),
    },
    {
      field: 'created',
      headerName: 'Sale Date',
      width: 150,
      valueGetter: (params) => formatTicketDate(params.row.created),
    },
    {
      field: 'product',
      headerName: 'Product',
      width: 180,
      valueGetter: (params) => formatProductInfo(params.row),
    },
    {
      field: 'productKey',
      headerName: 'Product Key',
      width: 150,
      valueGetter: (params) => formatProductKey(params.row),
    },
    {
      field: 'isUsed',
      headerName: 'Is Used?',
      width: 100,
      renderCell: (params) => <TicketIsUsedCell ticket={params.row} />,
      valueGetter: (params) => (params.row.isUsed ? 'true' : 'false'),
      type: 'singleSelect',
      valueOptions: [
        { value: 'true', label: 'Yes' },
        { value: 'false', label: 'No' },
      ],
    },
    {
      field: 'refund',
      headerName: 'İade',
      width: 100,
      filterable: false,
      valueGetter: (params) => formatTicketRefund(params.row),
      renderCell: (params) => <TicketRefundCell ticket={params.row} />,
    },
  ],
};
